<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-26 16:13:00
 * @LastEditors: lc
 * @LastEditTime: 2025-03-18 09:29:36
-->
<template>
  <div class="studymodule-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="listQuery.level_id"
                  filterable
                  clearable
                  placeholder="请选择等级">
            <Option v-for="(item,index) in levelList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('listQuery')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="addGoodCate"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           stripe
           :columns="columns1"
           ref="selection"
           :data="typelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加 弹层 -->
    <Drawer title="信息"
            v-model="showCreatTypeModal"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="cate"
            ref="addCate"
            :rules="cateValidate"
            action="javascript:void(0)">
        <FormItem label="等级"
                  prop="title">
          <Select v-model="cate.level_id"
                  clearable
                  filterable
                  placeholder="选择等级">
            <Option v-for="item in levelList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="名称"
                  prop="name">
          <Input v-model="cate.name"
                 placeholder />
        </FormItem>
        <FormItem label="描述">
          <Input type="textarea"
                 v-model="cate.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="cate.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="335"
                        :autoCropHeight="250"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:335*250,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="相册"
                  prop="album">
          <upload-thumb v-model="cate.album"
                        ref="uploadthumb2"
                        :defaultList="thumblist2"
                        :autoCropWidth="750"
                        :autoCropHeight="750"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:750*750'"></upload-thumb>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showCreatTypeModal = false">取消</Button>
        <Button type="primary"
                :loading="tijiaoloading"
                @click="createType('addCate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>
    
    <script>
import UploadThumb from "../common/thumb";
import UploadThumb2 from "../common/thumb";
export default {
  name: "studymodule-list",
  data () {
    const validateThumb = (rule, value, callback) => {
      if (this.$refs["uploadthumb"].uploadList.length == 0) {
        callback(new Error("请上传封面图"));
      } else {
        callback();
      }
    };
    const validateThumbTwo = (rule, value, callback) => {
      if (this.$refs["uploadthumb2"].uploadList.length == 0) {
        callback(new Error("请上传相冊"));
      } else {
        callback();
      }
    };
    return {
      loading: true,
      dataloading: true,
      tijiaoloading: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      levelList: [],
      // 类别
      cate: {
        name: "", // 当前类别
        sort: "", // 排序
        level_id: "" // 上级类别
      },
      formItem: {},
      thumblist: [],
      thumblist2: [],
      // 类别 规则
      cateValidate: {
        name: [
          {
            required: true,
            message: "名称必须填写",
            trigger: "blur"
          }
        ],
        thumb: [
          { required: true, validator: validateThumb, trigger: "change" }
        ],
        album: [
          { required: true, validator: validateThumbTwo, trigger: "change" }
        ],
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "名称",
          minWidth: 120,
          key: "name",
          render: (h, params) => {
            return h(
              "span",
              {
                style: {
                  marginLeft: params.row.left + "px"
                }
              },
              params.row.name
            );
          }
        },
        {
          title: "等级",
          minWidth: 300,
          key: "level_name",
        },
        {
          title: "描述",
          minWidth: 300,
          key: "describe",
        },
        {
          title: "排序",
          key: "sort",
          minWidth: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "InputNumber",
                {
                  props: {
                    min: 0,
                    value: params.row.sort,
                    size: "small",
                    number: true
                  },
                  on: {
                    "on-change": value => {
                      this.sort(params.row.id, value);
                    }
                  }
                },
                "排序"
              )
            ]);
          }
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            if (params.row.status == 0) {
              return h('div', [
                h('i-switch', {
                  props: {
                    value: params.row.status == 0 ? true : false   //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    'on-change': (value) => {
                      this.changeStatus(params.row.id, value)
                    }
                  }
                }, '开关')
              ]);
            } else {
              return h('div', [
                h('span', {}, params.row.status)
              ]);
            }

          }
        },
        {
          title: "操作",
          key: "action",
          minWidth: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.filelist(params.row.id);
                    }
                  }
                },
                "知识学习"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.tikulist(params.row.id);
                    }
                  }
                },
                "题库"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.editType(params.row.id);
                    }
                  }
                },
                "修改"
              ),

              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      typelist: [], //类别列表
      listQuery: [],
      showCreatTypeModal: false,
      currentId: 0 // 编辑类别，当前类别id
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getlevelList();
  },
  components: {
    UploadThumb,
    UploadThumb2
  },
  methods: {
    filelist: function (id) {
      this.$router.push(`/studymodulefile/list/${id}`);
    },
    tikulist: function (id) {
      this.$router.push(`/tiku/list/${id}`);
    },
    getlevelList: function () {
      var params = {
        page: 1,
        size: 20,
      };
      this.$api.studylevel.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.levelList = res.result.list;
        }
      });
      return;
    },
    // 获取类别列表
    getTableList: function () {
      var self = this;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.studymodule.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var params = {
        page: this.pages.page,
        size: this.pages.size,
        level_id: this.listQuery.level_id
      };
      this.$api.studymodule.list(params).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.typelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 添加
    addGoodCate: function () {
      this.currentId = 0;
      this.cate = {
        name: "",
        describe: "",
        thumb: "",
        level_id: "",
      };
      this.thumblist = new Array();
      this.thumblist2 = new Array();
      this.tijiaoloading = false;
      this.showCreatTypeModal = true;
    },
    // 编辑类别
    editType: function (id) {
      this.currentId = id;
      this.showCreatTypeModal = true;
      this.tijiaoloading = false;
      this.thumblist = new Array();
      this.thumblist2 = new Array();
      this.$api.studymodule.detail({ id: id }).then(res => {
        if (res.code == 200) {
          this.cate.name = res.result.name;
          this.cate.sort = res.result.sort;
          this.cate.describe = res.result.describe;
          this.cate.thumb = res.result.thumb;
          this.cate.level_id = res.result.level_id;
          if (this.cate.thumb != null && this.cate.thumb != "") {
            this.thumblist.push({
              name: this.cate.thumb,
              url: this.cate.thumb,
              status: "finished"
            });
          }
          if (res.result.album != null && res.result.album.length > 0) {
            for (var s in res.result.attrShow) {
              this.thumblist2.push({
                name: res.result.attrShow[s],
                url: res.result.attrShow[s],
                status: "finished"
              });
            }
          }
        }
      });
    },
    // 提交新类别
    createType: function (name) {
      this.tijiaoloading = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.cate.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.cate.thumb = null;
          }
          if (this.$refs["uploadthumb2"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumb2"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.cate.album = finalAttrs.substring(0, finalAttrs.length - 1);
            }
          }
          let params = {
            thumb: this.cate.thumb,
            name: this.cate.name, // 分类名称
            describe: this.cate.describe,
            level_id: this.cate.level_id,
            album: this.cate.album
          };
          if (this.currentId == null || this.currentId == 0) {
            this.tijiaoloading = false;
            this.$api.studymodule.create(params).then(res => {
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          } else {
            params.id = this.currentId;
            this.$api.studymodule.edit(params).then(res => {
              this.tijiaoloading = false;
              if (res.code == 200) {
                this.showCreatTypeModal = false;
                this.getTableList();
              }
            });
          }
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.tijiaoloading = false;
          this.$nextTick(() => {
            this.tijiaoloading = true;
          });
        }
      });
      this.tijiaoloading = false;
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.studymodule.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
        }
      });
    },
    sort: function (id, sort) {
      this.$api.studymodule.sort({ id: id, sort: sort }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.getTableList();
        }
      });
    },
    // 删除
    removeType: function (id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>是否确定删除该类别？</p>",
        onOk: () => {
          this.$api.studymodule
            .remove({
              id: id
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
  }
};
    </script>